import src from "IMAGE";
export default { src, width: 204, height: 62, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AIqIgnR0cm9mJiYmHyYmJiAnJycgKCgoICUlJR4jIyMbAJORjoJ3dnRtIyMjHSkpKSIqKioiJCQkHScnJyAqKiohIbsOp2GxuqoAAAAASUVORK5CYII="};
